/** Decorative props animate independently of the transparent mascot PNG. */
export function WorkmateTaskArt({
  scene,
  onError,
}: {
  scene: 'juggling' | 'team' | 'approvals';
  onError: () => void;
}) {
  return (
    <svg viewBox="0 0 240 240" focusable="false" data-scene={scene}>
      <g className="workmate-loader__breath">
        <image
          href={`/assets/mascot/workmate-${scene}-v1.png`}
          x={scene === 'juggling' ? 0 : -20}
          y={scene === 'juggling' ? 25 : 20}
          width={scene === 'juggling' ? 240 : 220}
          height="220"
          onError={onError}
        />
      </g>
      {scene === 'juggling' &&
        [0, 1, 2].map((i) => (
          <g key={i} className="workmate-loader__toss" style={{ animationDelay: `${-i * 0.8}s` }}>
            <rect
              x="-12"
              y="-15"
              width="24"
              height="30"
              rx="5"
              fill="#f2fcff"
              stroke="#00a7b5"
              strokeWidth="2"
            />
            <path
              d="M-6 -5H6M-6 1H6M-6 7H2"
              stroke="#007a91"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </g>
        ))}
      {scene === 'team' && (
        <>
          <path
            d="M142 101H177V179"
            fill="none"
            stroke="#24bacb"
            strokeWidth="2"
            strokeDasharray="3 4"
          />
          {[0, 1, 2].map((i) => (
            <g key={i} transform={`translate(156 ${58 + i * 54})`}>
              <g className="workmate-loader__member" style={{ animationDelay: `${-i * 1.1}s` }}>
                <rect
                  width="62"
                  height="42"
                  rx="8"
                  fill="#eafaff"
                  stroke="#00a7b5"
                  strokeWidth="2"
                />
                <circle cx="17" cy="14" r="6" fill="#008d9d" />
                <path d="M7 32Q7 21 17 21Q27 21 27 32" fill="#008d9d" />
                <path
                  d="M35 15H53M35 24H48"
                  stroke="#48738b"
                  strokeWidth="3"
                  strokeLinecap="round"
                />
              </g>
            </g>
          ))}
        </>
      )}
      {scene === 'approvals' && (
        <g transform="translate(148 79)">
          <rect width="76" height="108" rx="8" fill="#f2fcff" stroke="#008d9d" strokeWidth="3" />
          <rect x="21" y="-6" width="34" height="13" rx="4" fill="#008d9d" />
          {[0, 1, 2].map((i) => (
            <g key={i} transform={`translate(12 ${24 + i * 28})`}>
              <rect width="12" height="12" rx="3" fill="none" stroke="#81a5b4" strokeWidth="2" />
              <path d="M23 6H50" stroke="#81a5b4" strokeWidth="3" strokeLinecap="round" />
            </g>
          ))}
          <rect
            className="workmate-loader__review"
            x="6"
            y="17"
            width="64"
            height="26"
            rx="5"
            fill="#00bac9"
            fillOpacity=".2"
            stroke="#00a7b5"
            strokeWidth="2"
          />
        </g>
      )}
    </svg>
  );
}
